<template>
  <div id="questionContainer" class="questions" :class="'question-'+question.id">
    <radio
      v-if="question.type == 'radio_button'"
      v-model="question.answer"
      :options="question.options"
    />

    <check-box
      v-if="question.type == 'check_box'"
      v-for="option in question.options"
      v-model="option.selected"
      :key="option.id"
      :label="option.hint"
      :id="option.id"
    />

    <custom-select
      v-if="question.type == 'select'"
      v-model="question.answer"
      :submited="submited"
      :required="question.required"
      :label="question.hint"
      :options="question.options"
      name="options"
    />

    <edit-text
      v-if="question.type == 'edit_text'"
      v-model="question.answer"
      :id="question.id"
      :mask="question.mask"
      :rule="question.rule"
      :isHidden="false"
      :placeholder="question.placeholder"
      :label="question.hint"
    />

    <auto-complete-edit-text
      v-if="question.type == 'autocomplete_edit_text'"
      v-model="question.answer"
      :id="question.id"
      :isHidden="false"
      :source="question.source"
      :placeholder="question.placeholder"
      :label="question.hint"
    />

    <duplicate-previous-button
      v-if="question.type == 'duplicate_previous_field'"
      :id="question.id"
      :isHidden="false"
      :title="question.hint"
      @addToJSON="$emit('duplicatePreviousQuestion')"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Radio from "./fields/Radio";
import Checkbox from "./fields/Checkbox";
import EditText from "./fields/EditText";
import CustomSelect from "./fields/Select";
import AutoCompleteEditText from "./fields/AutoCompleteEditText";
import DuplicatePreviousButton from "./fields/DuplicatePreviousButton";
import DuplicatePreviousButtonVue from "./fields/DuplicatePreviousButton.vue";
Vue.use(Vuelidate);

export default {
  name: "question",
  components: {
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [EditText.name]: EditText,
    [CustomSelect.name]: CustomSelect,
    [AutoCompleteEditText.name]: AutoCompleteEditText,
    [DuplicatePreviousButtonVue.name]: DuplicatePreviousButton
  },
  props: ["question", "submited"],
  data() {
    return {
      childValue: null
    };
  },
  methods: {
  }
};
</script>
<style lang="scss">
#questionContainer {
  min-height: 85px;
  overflow: hidden;
}

.v-input__slot {
  border-radius: 4px;
}

.container .row {
  margin-left: 0;
  margin-right: 0;
}

.h2.question-title {
  color: #535353;
  font-size: 15px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue